import { useState, useMemo } from 'react';

// Filters entries by title search query
export function useEntrySearch(entries) {
    const [search, setSearch] = useState('');

    const filtered = useMemo(() => entries.filter((e) => e.title?.toLowerCase().includes(search.toLowerCase())), [entries, search]);

    return { search, setSearch, filtered };
}
